import { render, staticRenderFns } from "./TransferBookingExcel.vue?vue&type=template&id=bbcb3fc8&"
import script from "./TransferBookingExcel.vue?vue&type=script&setup=true&lang=js&"
export * from "./TransferBookingExcel.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports